import { useState } from "react";
import { AnimatePresence } from "framer-motion";

import Button from "components/Button";
import Modal from "components/Modal";
import usePhase from "utils/usePhase";

import submitUnfinishedRequest from "utils/submitUnfinishedRequest";
import updateUnfinishedRequest from "utils/updateUnfinishedRequest";
import SendEmailModal from "./SendEmailModal";

interface SendPdfButtonProps {
  data: Record<string, any>;
  diffData?: Record<string, any>;
  draftHash?: string | null;
  icon?: boolean;
}

const SendPdfButton = ({ data, diffData, draftHash, icon }: SendPdfButtonProps) => {
  const t = usePhase("summary");

  const [emailModalHash, setEmailModalHash] = useState<string | null>(null);
  const [emailSent, setEmailSent] = useState(false);
  const [errorWithCopy, setErrorWithCopy] = useState(false);

  const openEmailModal = () => {
    if (diffData) {
      updateUnfinishedRequest(diffData, (result) => {
        if (result.success) setEmailModalHash(result.hash);
        else setErrorWithCopy(true);
      });
    } else if (draftHash) {
      setEmailModalHash(draftHash);
    } else {
      submitUnfinishedRequest(data, (result) => {
        if (result.success) setEmailModalHash(result.hash);
        else setErrorWithCopy(true);
      });
    }
  };

  return (
    <>
      <Button
        icon={icon ? "email" : undefined}
        onClick={openEmailModal}
        disabled={!data.acceptedPrivacyPolicy}
      >
        {t("send_pdf_to_email")}
      </Button>
      <AnimatePresence>
        {emailSent && (
          <Modal closeModal={() => setEmailSent(false)}>
            <span className="h2">{t("email_sent")}</span>
          </Modal>
        )}
        {errorWithCopy && (
          <Modal closeModal={() => setErrorWithCopy(false)}>
            <span className="h2">{t("error_with_copying_link")}</span>
          </Modal>
        )}
      </AnimatePresence>
      {emailModalHash && (
        <SendEmailModal
          hash={emailModalHash}
          onClose={() => setEmailModalHash(null)}
          onSuccess={() => {
            setEmailModalHash(null);
            setEmailSent(true);
            setTimeout(() => setEmailSent(false), 3000);
          }}
        />
      )}
    </>
  );
};

export default SendPdfButton;
